<template>
  <keep-alive>
    <option
      v-bind:value="optionKey()"
      v-bind:key="optionKey()">
      {{ optionLabel(stop) }}
    </option>
  </keep-alive>
</template>

<script>
export default {
  name: "ApthScheduleLineOptions",
  props: {
    lineMnemo: {
      type: String,
      required: false,
      default: null,
    },
    stop: {
      type: Object,
      required: true,
      default: () => {},
    },
    withDestinations: {
      type: Boolean,
      required: false,
      default: true
    },
    categoryKey: {
      type: Number,
      required: false,
      default: 0,
    },
    lineKey: {
      type: Number,
      required: false,
    },
    finalKey: {
      type: Number,
      required: true,
    },
    optionSeparator: {
      type: String,
      required: true,
      default: "||",
    }
  },
  methods: {
    optionKey: function() {
      let separator = this.optionSeparator;
      return (this.withDestinations) ? 
        `${this.categoryKey}${separator}${this.lineKey}${separator}${this.finalKey}` : `${this.categoryKey}${separator}${this.finalKey}`;
    },
    optionLabel: function(stop) {
      return (this.withDestinations) ? `${this.lineMnemo} ${stop.destinationName}` : stop.line.mnemo;
    },
  },
};
</script>